// extracted by mini-css-extract-plugin
export var cartIcon = "cart-widget-module--cart-icon--3cd7c";
export var cartWidget = "cart-widget-module--cart-widget--4f91b";